import { useState } from "react";

import { User } from "models";

type UsersModals = {
  createUserModal: boolean;
  editUserModal: boolean;
  deleteUserModal: boolean;
};

export enum USERS_MODALS {
  CreateUserModal = "createUserModal",
  EditUserModal = "editUserModal",
  DeleteUserModal = "deleteUserModal"
}

export const useUsers = () => {
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [{ createUserModal, deleteUserModal, editUserModal }, setModal] = useState<UsersModals>({ createUserModal: false, deleteUserModal: false, editUserModal: false });

  const handleOpenModal = (modalName: USERS_MODALS) => setModal(prevModals => ({ ...prevModals, [modalName]: true }));
  const handleCloseModal = (modalName: USERS_MODALS) => setModal(prevModals => ({ ...prevModals, [modalName]: false }));

  const handleSelectUser = (data: User) => {
    setSelectedUser(data);
    handleOpenModal(USERS_MODALS.EditUserModal);
  };

  return { createUserModal, deleteUserModal, editUserModal, selectedUser, handleSelectUser, handleCloseModal, handleOpenModal };
};
